import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Link } from 'react-router-dom';

const HealthcareTransformation = () => {
  return (
    <>
      <Element
      name="HealthcareTransformation"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 col-lg-6 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-left"
                title = "Healthcare Industry Transformation"
              />
              <p className="mt-4">AI is transforming healthcare workflows-from diagnosis to therapy, from speech support to intelligent monitoring. Our platform empowers practitioners and startups to deploy AI ethically, scalably, and cost-effectively.</p>
              <h6 className="mt-5 mb-4">Transformation Highlights</h6>
              <ul>
                <li>From Generic ASR → To Condition-Specific Accessibility Tools</li>
                <li>From Manual Monitoring → To AI-Powered Patient Observability</li>
                <li>From Delayed Results → To Real-Time Data-Informed Decisions</li>
                <li>From Centralized Dependence → To Edge Intelligence at Point of Care</li>
              </ul>
              <Link className="edu-btn btn-primary" to="/products/m2m-edge-ai">Discover Edge AI Products</Link>
            </div>
            <div className="col-12 col-lg-6 mt-4 mt-md-0 px-0 px-md-4 d-flex flex-row flex-wrap align-items-center justify-content-center">
              <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-blue p-4 h-100">
                    <h5 className="mtsc-heading mb-0">
                      3X
                    </h5>
                    <small>Accuracy for Speech Impairment Recognition</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-green p-4 h-100">
                    <h5 className="mtsc-heading mb-0">
                      -40%
                    </h5>
                    <small>Delay in Diagnosis through Real-Time Tools</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-purple p-4 h-100">
                    <h5 className="mtsc-heading mb-0">
                      +25%
                    </h5>
                    <small>Patient Engagement via Accessible Interfaces</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-orange p-4 h-100">
                    <h5 className="mtsc-heading mb-0">
                      -35%
                    </h5>
                    <small>Manual Processing in Clinical Workflows</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default HealthcareTransformation;